export type {
  Category,
  Combo,
  LayoutPosition,
  LayoutType,
  MenuBoardConfig,
  MenuBoardLayout,
  MenuInput,
  Product,
  ScoredItem,
  ScoringWeights,
  Screen,
  Section,
  SectionItem,
  SectionType,
} from "./types.js";

export { DEFAULT_CONFIG, resolveConfig } from "./config.js";
export { scoreAndRank } from "./scoring.js";
export { generateLayout } from "./layout/index.js";

import type { MenuBoardConfig, MenuBoardLayout, MenuInput } from "./types.js";
import { resolveConfig } from "./config.js";
import { generateLayout } from "./layout/index.js";
import { scoreAndRank } from "./scoring.js";

export function generateMenuBoard(
  input: MenuInput,
  config?: Partial<MenuBoardConfig>,
): MenuBoardLayout {
  const resolved = resolveConfig(config);
  const scored = scoreAndRank(input, resolved.scoringWeights);
  return generateLayout(scored, input, resolved);
}
